// extracted by mini-css-extract-plugin
export var drawerPaper = "_25-0";
export var itemImage = "_25-1";